import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'pt-BR',
  messages: {
    'en-US': {
      'home': "One more Tweet and then it’s bedtime",
      'about-us': {
        'title': 'About us',
        'description': "Twitter is a free social networking site where users broadcast short posts known as tweets. These tweets can contain text, videos, photos or links.",
        'service': {
          'title': 'Our services',
          'row1': ['Tweets', 'Moments', 'Ads'],
        }
      },
      'portfolio': {
        'title': 'Products',
        'advised': 'Advised',
        'products': [
          { title: "Tweets", url: "img/portfolio/tweet.png" },
          { title: "Data analytics", url: "https://cdn.cms-twdigitalassets.com/content/dam/business-twitter/analytics/account-home-icon.png.twimg.2560.png" },
          { title: "Everything on the app", url: "img/portfolio/app.png" },
        ],
        'cases': {
          'first-product': "Data analytics",
          'first-product-desc': "Analytics is the systematic computational analysis of data or statistics."
        }
      },
      'team_label': 'Team',
      'team': [
        {
          title: 'Founding Partner',
          shortDescription: 'Founding Partner of LKC Capital, responsible for ongoing project execution, client relationship, due diligence, and buy side projects.',
          description: 'Holds a BSc in Law by the University of Blumenau and holds an MBA in finance, auditing, and controllership by Fundação Getúlio Vargas. Developed longstanding relationships across several years advising some of the most relevant companies in the South of Brazil'
        }, // Leonardo
        {
          title: 'Managing Partner',
          shortDescription: 'Responsible for ongoing Project Execution & Pre-M&A Consulting.',
          description: 'Holds a BSc in Economics by Universidade Presbiteriana Mackenzie, with semesters abroad in the University of Liechtenstein, Turku School of Economics (Finland) and corporate trainings in New York.',
          footer: 'Considerable experience and technical know-how in Investment Banking, Valuation, and Pre-M&A Consulting. Has worked on several financial institutions, such as: Barclays, G5 Evercore, Deutsche Bank, Santander and HSBC. Was the founding partner of BrightSea Consulting, later acquired by LKC Capital, and is currently a board member at Agriness Sistemas e Tecnologias de Informação.'
        }, // Luiz
        {
          title: 'Partner',
          shortDescription: 'Responsible for client relationship, market prospection and sector, tech and company identification for M&A operations.',
          description: 'Has a broad experience in the growth and transformation of businesses through strategic development and financial structuring with venture capital and private equity resources. More than 20 years living as an executive for industrial, commercial, tech and financial services companies in Brazil, USA, Germany, Netherlands and Finland.',
          footer: 'BSC in Economics and Business Administration, with an MBA in finance by Fundação Getúlio Vargas. Speaks Portuguese, English and German.'
        }, // Aristides
      ]
    },
    'pt-BR': {
      'home': "Mais um Tweet e então é hora de dormir",
      'about-us': {
        'title': 'Sobre nós',
        'description': "O Twitter é um site de rede social gratuito onde os usuários transmitem postagens curtas conhecidas como tweets. Esses tweets podem conter texto, vídeos, fotos ou links.",
        'service': {
          'title': 'Nossos Serviços',
          'row1': ['Tweets', 'Moments', 'Anúncios'],
        },
      },
      'portfolio': {
        'title': 'Produtos',
        'advised': 'Assessoramos',
        'products': [
          { title: "Tweets", url: "img/portfolio/tweet.png" },
          { title: "Análise de dados", url: "https://cdn.cms-twdigitalassets.com/content/dam/business-twitter/analytics/account-home-icon.png.twimg.2560.png" },
          { title: "Na palma da sua mão", url: "img/portfolio/app.png" },
        ],
        'cases': {
          'first-product': "Análise de dados",
          'first-product-desc': "Métricas das campanhas de anúncios",
          'kiper': 'em seu processo de fusão, dando origem ao',
          'involves_3': 'em seu investimento na',
          'involves_2': 'na venda de participação minoritária para',
          'seventh': 'na venda de 100% de seu capital social para',
          'vialaser': 'em sua venda de participação minoritária para grupo de investidores',
          'nave': 'em sua captação de<br />investimento e venda para',
          'clipescola': 'em sua venda de<br />participação minoritária para',
          'involves':  'na aquisição de solução de<br />reconhecimento por imagem da',
          'crossx': 'na venda de sua operação<br />para',
          'illtech': 'em sua reestruturação<br />societária',
          'agriness': 'em sua venda de<br />participação para',
          'jtech': 'na venda de participação<br />controladora para', 
          'bravi': 'em sua venda de<br />participação minoritária para',
          'agriness_2': 'em sua aquisição de<br />ativos de IoT para<br />a construção do',
          'ahgora': 'em sua venda de<br />participação minoritária para',
          'studos': 'na venda de 100% de <br/>seu capital social para',
          'cromai': 'na venda de participação <br/> minoritária para',
          'aprovatotal': 'na venda de participação minoritária para',
          'payface': 'Em sua captação Series A <br/> com o',
          'way2_votorantim': 'na venda de 50% de seu capital para a',
        }
      },
      'team_label': 'Equipe',
      'team': [
        {
          title: 'Sócio Fundador',
          shortDescription: 'Responsável pela execução de projetos em andamento, relacionamento com clientes, e projetos de aquisição.',
          description: 'Possui graduação em direito pela FURB e MBA em finanças, auditoria e controladoria pela Fundação Getúlio Vargas. Desenvolveu relacionamentos duradouros e valiosos com algumas das mais relevantes empresas do Sul do país após anos de assessoria financeira na região.'
        }, // Leonardo
        {
          title: 'Sócio Diretor',
          shortDescription: 'Responsável pela execução de projetos em andamento e consultoria de preparação para M&A.',
          description: 'Graduado em economia pela Universidade Presbiteriana Mackenzie, com passagens pela Universidade de Liechtenstein, Turku School of Economics (Finlândia) e treinamentos corporativos realizados em Nova Iorque.',
          footer: 'Experiência considerável e amplo know-how técnico em Investment Banking, Valuation, e consultoria de preparação para M&A. Trabalhou em diversas instituições financeiras: Barclays, G5 Evercore, Deutsche Bank, Santander e HSBC. Foi sócio fundador da BrightSea Consulting, empresa adquirida pela LKC Capital, e é membro do conselho de administração da Agriness Sistemas e Tecnologias de Informação. '
        }, // Luiz
        {
          title: 'Sócio',
          shortDescription: 'Sócio da LKC Capital, focado na prospecção de mercados e identificação de segmentos de negócios, tecnologias e empresas para operações de M&A. Execução de operações de M&A, diligência estratégica e relacionamento com clientes.',
          description: 'Ampla experiência no crescimento e transformação de negócios através de desenvolvimento estratégico e estruturação financeira com recursos de venture capital e private equity. Mais de 20 anos de vivência como executivo em empresas industriais, comerciais, de tecnologia da informação e de serviços financeiros no Brasil, Estados Unidos, Alemanha, Holanda e Finlândia.',
          footer: 'Graduado em Economia e Administração, com MBA em Finanças Empresariais. Fluente em português, inglês e alemão. '
        }, // Aristides
      ]
    }
  }
})
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  i18n
}).$mount('#app')
